import { render, staticRenderFns } from "./BjiOrderSummaryListTable.vue?vue&type=template&id=36653a95&scoped=true&lang=pug"
import script from "./BjiOrderSummaryListTable.vue?vue&type=script&lang=js"
export * from "./BjiOrderSummaryListTable.vue?vue&type=script&lang=js"
import style0 from "./BjiOrderSummaryListTable.vue?vue&type=style&index=0&id=36653a95&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36653a95",
  null
  
)

export default component.exports